import React from 'react';
import PropTypes from 'prop-types';
import { Route, useHistory } from 'react-router-dom';
import { useContactsExtended } from 'pages/contactsExtended/hooks/useContactsExtended';
import { ExtendedContact } from 'pages/contactsExtended/extendedContact';
import usePageTitle from '../../hooks/usePageTitle';
import { CreateList } from '../list/createList';

export const AddContacts = ({ sharedList }) => {
  const {
    queryParams,
    selectedRows,
    setSelectedRows,
    data,
    customFields,
    isLoading,
    isFetching,
    filtersCount,
    meta,
    showAllContactsEmptyState,
    showListContactsEmptyState,
    onLoadMore,
    onChangeSelectedContact,
    onSetFilters,
    activeNetwork,
    listId,
    isLoadingAI,
  } = useContactsExtended({ allList: true, page: 'list:add' });
  const history = useHistory();

  const { name: listName } = sharedList || {};
  usePageTitle(listName);

  return (
    <>
      <ExtendedContact
        onSetFilters={onSetFilters}
        queryParams={queryParams}
        selectedRows={selectedRows}
        setSelectedRows={setSelectedRows}
        onChangeSelectedContact={onChangeSelectedContact}
        onLoadMore={onLoadMore}
        data={data?.ids?.map((id) => data?.entities[id]) ?? []}
        customFields={customFields}
        isLoading={isLoading}
        isFetching={isFetching}
        meta={meta}
        filtersCount={filtersCount}
        activeNetwork={activeNetwork}
        showAllContactsEmptyState={showAllContactsEmptyState}
        showListContactsEmptyState={showListContactsEmptyState}
        showAddToLisButton
        showListFilters
        list={sharedList}
        bulkActions={['add-to-list', 'add-tag', 'export', 'delete', 'clear-selection']}
        page="list:add"
        filtersTitle="Filter all contacts"
        isLoadingAI={isLoadingAI}
        tableSx={{ height: 'calc(100dvh - 133px)' }}
        cardSx={{ height: 'calc(100dvh - 133px)' }}
      />
      <Route exact path={`/networks/${activeNetwork.slug}/list/:listId/add-contacts/lists/settings`}>
        <CreateList
          goBack={() => {
            history.push(`/networks/${activeNetwork.slug}/list/${listId}/add-contacts${history.location.search}`);
          }}
        />
      </Route>
    </>
  );
};

AddContacts.propTypes = {
  sharedList: PropTypes.object,
};

AddContacts.defaultProps = {
  sharedList: null,
};
